import { ApolloClient, from, InMemoryCache } from '@apollo/client';
import { ErrorHandler, onError } from '@apollo/client/link/error';

import { createMockLink, CreateMockLinkOptions } from './link';

type ApolloMockClientOptions = CreateMockLinkOptions & {
  cache?: InMemoryCache;
  // Optional custom error handler
  onError?: ErrorHandler;
};

export const createApolloMockClient = (opts?: ApolloMockClientOptions) => {
  const {
    cache = new InMemoryCache(globalThis.__APOLLO_STATE__),
    onError: customOnError = () => {},
    ...restOpts
  } = { ...opts };

  const errorLink = onError(customOnError);

  const graphqlClient = new ApolloClient({
    cache,
    link: from([errorLink, createMockLink(restOpts)]),
  });

  return graphqlClient;
};
